module.exports = __webpack_public_path__ + "img/_MG_3699.ad497658.jpg";